import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Phone } from "lucide-react";
import { PHONE_TEL, PHONE_DISPLAY } from "../../lib/site";
import { LegalFooter } from "./LegalFooter";

export const H2 = ({ children }) => (
  <h2 className="font-heading text-2xl sm:text-3xl text-zinc-950 tracking-tight mt-12 mb-4">{children}</h2>
);

export const P = ({ children }) => (
  <p className="text-zinc-700 leading-relaxed mb-4 text-[15px]">{children}</p>
);

export const UL = ({ children }) => (
  <ul className="mb-4 space-y-2">{children}</ul>
);

export const LI = ({ children }) => (
  <li className="text-zinc-700 leading-relaxed text-[15px] pl-5 relative">
    <span className="absolute left-0 top-[0.6em] h-1.5 w-1.5 bg-red-700" />
    {children}
  </li>
);

export const LegalLayout = ({ title, updated, intro, children, testid }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `${title} | Scrapman's Metal Recycling`;
  }, [title]);

  return (
    <div className="bg-white min-h-screen flex flex-col" data-testid={testid}>
      <header className="border-b border-zinc-200 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3" data-testid="legal-home-link">
            <img src="/favicon.png" alt="Scrapman's mark" className="h-8 w-8" />
            <div className="leading-none">
              <span className="font-heading text-base tracking-wide text-zinc-950 block">SCRAPMAN'S</span>
              <span className="text-[10px] font-bold tracking-[0.28em] text-red-700 uppercase">Metal Recycling</span>
            </div>
          </Link>
          <a
            href={PHONE_TEL}
            className="inline-flex items-center gap-2 bg-red-700 text-white px-4 py-2 font-heading text-xs sm:text-sm tracking-wider hover:bg-red-800 transition-colors"
            data-testid="legal-call-cta"
          >
            <Phone className="h-4 w-4" />
            {PHONE_DISPLAY}
          </a>
        </div>
      </header>

      <main className="flex-1 max-w-3xl mx-auto px-4 sm:px-6 py-14 sm:py-20 w-full">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-zinc-500 hover:text-red-700 transition-colors"
          data-testid="legal-back-link"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to site
        </Link>

        <h1 className="font-heading text-4xl sm:text-5xl text-zinc-950 tracking-tight mt-6 leading-[1.05]">
          {title}
        </h1>
        <p className="mt-3 text-xs font-bold uppercase tracking-widest text-zinc-500">Last updated: {updated}</p>
        <div className="mt-8 border-l-4 border-red-700 bg-zinc-50 p-5">
          <p className="text-sm font-semibold text-zinc-800">{intro}</p>
        </div>

        <div className="mt-4">{children}</div>
      </main>

      <LegalFooter />
    </div>
  );
};
